import type {MenuProps} from '@chakra-ui/react';
import {Menu} from '@chakra-ui/react';
import type {FC, ReactNode} from 'react';

type Props = {
  children: ReactNode;
} & MenuProps;

const ContextMenu: FC<Props> = ({...props}) => {
  return <Menu {...props} />;
};

export default ContextMenu;
export type {Props as ContextMenuProps};
ContextMenu.displayName = `ContextMenu`;
